export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-stop-da02a0c5bd7f9d749c24c5579c1016e7.svg";